import HelpIcon from '@mui/icons-material/Help';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';

import { TooltipPlacement } from '../../../types/forms';

interface IProps {
  placement?: TooltipPlacement;
  title: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const TooltipMUI: React.FC<IProps> = ({
  placement = TooltipPlacement.TopStart,
  title,
  size = 'small',
  className,
}) => {
  return (
    <Tooltip title={title} arrow placement={placement} className={className}>
      <IconButton size={size}>
        <HelpIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};
